import React from 'react';
import ImgPhoto from '../../../assets/images/image-choose-photo.png';
const Cash = () => {
  return (
    <div className="flex flex-col my-4">
      <p className=" font-semibold">Unggah foto KTP</p>
      <label class=" bg-gray-300 px-2 py-4 flex flex-col items-center justify-center rounded-lg cursor-pointer mt-2">
        <img src={ImgPhoto} className="h-20" alt="" />
        <input class="form-input hidden" type="file" placeholder="Jane Doe" />
        <p className="text-sm mt-2">Pilih Foto</p>
      </label>
      <label htmlFor="" className="w-full my-3">
        <input
          type="text"
          className="form-input bg-gray-300 px-3 text-sm rounded-lg outline-none w-full"
          placeholder="Masukan Nomor NIK KTP"
        />
      </label>
      <p className=" font-semibold">Unggah foto anda bersama KTP</p>
      <label class=" bg-gray-300 px-2 py-4 flex flex-col items-center justify-center rounded-lg cursor-pointer mt-2">
        <img src={ImgPhoto} className="h-20" alt="" />
        <input class="form-input hidden" type="file" placeholder="Jane Doe" />
        <p className="text-sm mt-2">Pilih Foto</p>
      </label>
    </div>
  );
};

export default Cash;
